import { lazyGetBposNavBarDataHelper } from 'owa-fluid-tenantconfig';
import { CORS_MODE_NAME, FetchRequestOptions, fetchService } from 'owa-data-provider-info-fetcher';
import { logDriveIdNotFound, logNoBPOSForDriveId } from 'owa-fluid-datapoints';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import type NavBarData from 'owa-service/lib/contract/NavBarData';

const FUNCTION_NAME = 'getDriveId';

// The driveID doesn't change so we cache it after fetching it once.
let driveId;

// VSO 83889 support ODC as well
export async function getDriveId() {
    if (!driveId) {
        const bposNavBarData: NavBarData | null = await lazyGetBposNavBarDataHelper.importAndExecute(
            FUNCTION_NAME
        );
        if (bposNavBarData) {
            const rootUrl = bposNavBarData.SPO_MySiteHostUrl;
            const requestUrl = rootUrl + '_api/v2.0/me/drive';

            const requestOptions: FetchRequestOptions = {
                method: 'GET',
                mode: CORS_MODE_NAME,
                body: undefined,
                datapointNamePrefix: FUNCTION_NAME,
            };

            const responseText = await fetchService(
                AttachmentDataProviderType.OneDrivePro,
                requestUrl,
                requestUrl,
                requestOptions,
                null // additionalHeaders
            );
            if (responseText) {
                driveId = JSON.parse(responseText).id;
            } else {
                logDriveIdNotFound();
            }
        } else {
            logNoBPOSForDriveId(FUNCTION_NAME);
        }
    }

    return driveId;
}
